import { useState } from "react";
import { PRICING } from "@/lib/content";
import { Btn, ArrowLink } from "@/components/kit";
import PayDialog from "@/components/PayDialog";
import { Reveal } from "@/lib/anim";

export const AMT = { strategy_60: 300, strategy_90: 450, margin_check: 690, first_run_sprint: 2400, supplier_search: 3900, category_rebuild: 9800, vip_day: 3200 };

export function OfferGrid({ items = PRICING, full = false }) {
  const [tier, setTier] = useState(null);

  const cta = (it) => {
    if (it.payable && it.target === "pay") {
      return (
        <Btn variant="clay" onClick={() => setTier({ id: it.id, label: it.name, amount: AMT[it.id] })} data-testid={`offer-pay-${it.id}`}>
          {it.cta}
        </Btn>
      );
    }
    return (
      <Btn to={it.target || "/book"} variant={it.id === "fit_call" ? "clay" : "outline"} data-testid={`offer-cta-${it.id}`}>
        {it.cta}
      </Btn>
    );
  };

  return (
    <>
      <div className={`grid gap-5 ${full ? "md:grid-cols-2" : "md:grid-cols-3"}`}>
        {items.map((it, i) => (
          <Reveal i={i % 3} key={it.id}>
            <div className="card h-full p-7 md:p-8 flex flex-col" data-testid={`offer-card-${it.id}`}>
              <div className="flex items-baseline justify-between gap-4">
                <h3 className="t-h3">{it.name}</h3>
                <span className="font-mono text-[var(--clay-deep)] text-lg whitespace-nowrap">{it.price}</span>
              </div>
              <p className="t-sm text-[var(--muted)] mt-2">{it.time}</p>
              {full && (
                <>
                  <ul className="mt-6 space-y-2.5">
                    {it.get.map((g) => (
                      <li key={g} className="flex gap-3 t-sm">
                        <span className="mt-[9px] w-1.5 h-1.5 bg-[var(--clay)] shrink-0" aria-hidden />
                        <span>{g}</span>
                      </li>
                    ))}
                  </ul>
                  <p className="t-sm text-[var(--muted)] mt-6"><span className="font-mono uppercase text-[12px] tracking-wide">Best for</span><br />{it.best}</p>
                  {it.note && <p className="t-caption text-[var(--muted)] mt-4">{it.note}</p>}
                </>
              )}
              <div className="mt-7 pt-1 flex-1 flex items-end">{cta(it)}</div>
            </div>
          </Reveal>
        ))}
      </div>
      {tier && <PayDialog tier={tier} onClose={() => setTier(null)} />}
    </>
  );
}
